import { createStyles } from '@mantine/emotion';

export const useStyles = createStyles((theme) => ({
  badge: {
    paddingRight: 3,
    backgroundColor: theme.colors.backgroundGray[6],
    color: 'black',
    borderRadius: '16px',
    marginRight: theme.spacing.xs,
    marginTop: theme.spacing.xs,
    border: 'none',
    textTransform: 'inherit',
    height: '28px',
    fontSize: '14px',
    padding: theme.spacing.xs,
    fontWeight: 400
  }
}));
